import Api from './Api'
import FileService from './FileService'
import { store } from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default class BuildingsService {
  constructor() { }

  static upload(file) {
    if (!file) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      let url = `/mdm/api/v1/orgs/${getOrgId()}/buildings/csv`;
      let data = new FormData();
      data.append('file', file);
      try {
        let response = await new Api().post(url, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        resolve(response);
      } catch (err) {
        reject(err);
      }
    });
  }

  static async pollUploadProgress(requestId) {
    if (!requestId) {
      throw 'Failed to check upload status (missing parameter requestId)';
    }

    let url = `/mdm/api/v1/orgs/${getOrgId()}/imports/${requestId}`;

    const executePoll = async (resolve, reject) => {
      try {
        let statusResponse = await new Api().get(url);
        let responseData = statusResponse.data;
        let status = responseData.importState;

        // Status will be one of (UNKNOWN, PENDING, RUNNING, COMPLETED, ERROR)
        if (status.toUpperCase() === 'COMPLETED') {
          return resolve(responseData);
        } else if (status.toUpperCase() === 'ERROR') {
          return reject('Upload Error');
        } else {
          setTimeout(executePoll, 1000, resolve, reject);
        }
      } catch (err) {
        return reject(err);
      }
    };

    return new Promise(executePoll);
  }

  static async downloadTemplate() {
    let url = `/mdm/api/v1/orgs/${getOrgId()}/buildings/csv`;
    try {
      let response = await new Api().get(url, {
        headers: {
          'Accept': 'text/csv'
        }
      });
      let filename = 'buildings.csv';
      let data = new Blob([response.data]);
      let disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('attachment') !== -1) {
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(disposition);
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      FileService.downloadDataAsFile(data, filename);
    } catch (err) {
      console.log('error:', err);
    }
  }

  static async getTableData(params = {}) {
    let url = `/mdm/api/v1/orgs/${getOrgId()}/buildings`;
    try {
      // 'true' means we omit the userId query param
      let response = await new Api(true).get(url, { params });
      return response.data;
    } catch (err) {
      return null;
    }
  }

  static async updateTableRow(id, updatedData) {
    let url = `/mdm/api/v1/orgs/${getOrgId()}/buildings/${id}`;
    try {
      // 'true' means we omit the userId query param
      let response = await new Api(true).patch(url, updatedData);
      return response;
    } catch (err) {
      return err.response;
    }
  }
}
